import { CustomFormItemProps, IFormComponent, } from '@Modules/atlas-form-core';
import { TRequired, } from 'atlas-shared/dist';
import { TranslateAndDisplayPhoneNumber, } from '@Utils';

export const FormComponentPhonenumberPreview: IFormComponent = ({ t, value, }: TRequired<CustomFormItemProps>) => {
  return <TranslateAndDisplayPhoneNumber t={t} phone_number={value} />;
};
